// extracted by mini-css-extract-plugin
module.exports = {"isBlue":"Button_isBlue_3_LeZ"};